(function () {
  'use strict';

  var cache = {};

  function fetchSummary(appUrl, shop, productId) {
    var key = shop + ':' + productId;
    if (cache[key]) return cache[key];
    cache[key] = fetch(
      appUrl + '/api/reviews/summary/' + productId + '?shop=' + encodeURIComponent(shop)
    )
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[key];
  }

  function renderStars(rating, starColor) {
    var html = '';
    for (var i = 1; i <= 5; i++) {
      var filled = i <= Math.round(rating);
      html += '<span style="color:' + (filled ? starColor : '#ccc') + '">&#9733;</span>';
    }
    return html;
  }

  function init() {
    var els = document.querySelectorAll('[data-dml-stars]');
    if (!els.length) return;

    els.forEach(function (el) {
      if (el.dataset.loaded) return;
      el.dataset.loaded = '1';

      var productId = el.dataset.productId;
      var shop      = el.dataset.shop;
      var appUrl    = el.dataset.appUrl || 'https://reviews-rewards.vercel.app';
      var starColor = el.dataset.starColor || '#f5a623';
      var textColor = el.dataset.textColor || '#666666';

      if (!productId || !shop) return;

      fetchSummary(appUrl, shop, productId).then(function (data) {
        if (!data || !data.reviewCount || data.reviewCount < 1) return;
        el.innerHTML =
          '<span class="dml-stars__stars" style="letter-spacing:2px;">' +
            renderStars(data.averageRating || 0, starColor) +
          '</span>' +
          '<span class="dml-stars__count" style="color:' + textColor + ';font-size:0.8em;font-weight:600;letter-spacing:0.5px;">' +
            data.reviewCount + ' REVIEWS' +
          '</span>';
        el.style.display = 'flex';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run in theme editor when blocks are added/moved
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', init);
    document.addEventListener('shopify:section:load', init);
  }
})();
